import { IRolePermissionData, IUserPermissionUIPermission } from '../apps/apps.types';
import { BaseResponseType } from '../cognito/authResponse.types';
import { CashDrawerLogsType, CashDrawerType } from '../restaurant/cashDrawerLogs.types';
import { IRestaurantEmployee } from '../restaurant/restaurant.types';
import {
  EmployeePayTypeEnum,
  IUserRolesRequestType,
  SalaryType,
  UserPermissionItem,
} from '../user-roles/user-roles.types';
import { BenefitData } from './benefits.types';
import { UserRestaurantRelationsTypes } from './userRestaurants.types';

export interface IEmployee {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  emailVerifiedAt?: Date | null;
  fullname?: string;
  phoneNumber: string;
  phoneVerifiedAt?: Date | null;
  imgUrl?: string;
  posPin?: number;
  employeeDisplayId?: number;
  createdAt?: Date;
  updatedAt?: Date;
  employeeDocuments?: unknown[];
  userRestaurants?: UserRestaurantRelationsTypes[];
  cards?: unknown[];
  checkHqId?: string;
  userPermissions?: UserPermissionItem[];
}

export type EmployeeFilter = Partial<IEmployee>;

export enum EmployeeAppType {
  POS = 'pos',
  MOM = 'mom',
  ONLINE = 'online',
}

export enum EmployeeStatusType {
  INVITED = 'invited',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETED = 'deleted',
}

export enum PayrollOnboardingStatus {
  BLOCKING = 'blocking',
  NEEDS_ATTENTION = 'needs_attention',
  COMPLETED = 'completed',
}

export interface IEmployeeRating {
  id?: number;
  rating: number;
  employeeId?: number;
  employee?: IEmployee;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface UserRoleWithEmployeeType {
  id: number;
  salary: number;
  payType: string;
  fixedPeriod?: string;
  name?: string;
  salaryType?: SalaryType;
}

export interface EmployeeType {
  fullname?: string;
  id: string;
  posPin: number;
  employeeDisplayId: number;
  createdAt: Date;
  updatedAt: Date;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  imgUrl?: string;
  restaurantId?: number;
  userRoles?: UserRoleWithEmployeeType[];
  reviewCounts?: Record<string, number>;
  cashDrawers?: CashDrawerType[];
  tipsCollected?: CashDrawerLogsType[];
  operatedCashDrawerLogs?: CashDrawerLogsType[];
  clockInStatus?: boolean; // user is clockIn at that time or not
}

export interface UpdatePosPinResponseType extends BaseResponseType {
  data: EmployeeType | null;
}
export interface GetEmployeesResponseType extends BaseResponseType {
  data: EmployeeType[] | null;
}

export interface BodyUpdatePosPin {
  pos_pin: number;
}
export interface EmployeePaginationMetaType {
  itemsPerPage?: number;
  totalItems?: number;
  currentPage?: number;
  totalPages?: number;
  sortBy?: string[][];
  search?: string;
  searchBy?: string[];
}
export interface EmployeePaginationLinkType {
  first?: string;
  previous?: string;
  current?: string;
  next?: string;
  last?: string;
}
export interface PaginatedEmployeeType {
  data: EmployeeType[];
  meta?: EmployeePaginationMetaType;
  links?: EmployeePaginationLinkType;
  myEmployee: EmployeeType[];
}
export interface EmployeeFetchResponseType extends BaseResponseType {
  data: PaginatedEmployeeType | null;
}

//!------------------DASHBOARD---------------------//

export interface EmployeeI {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  emailVerifiedAt?: Date | null;
  fullname?: string;
  phoneNumber?: string;
  phoneVerifiedAt?: Date | null;
  imgUrl?: string;
  posPin?: number;
  employeeDisplayId?: number;
  createdAt?: Date;
  updatedAt?: Date;
  checkHqId?: string;
}

export interface IEmployeeListResponse {
  employees: IRestaurantEmployee[] | undefined;
  phoneNumbers: string[];
  emails: string[];
  totalCount: number;
}

export interface IEmployeeCreateRequest {
  businessId?: number;
  employee: EmployeeI;
}

export interface ICreateEmployeeRequest {
  businessId: number;
  restaurantId: number;
  employee: EmployeeI;
  userRole: IUserRolesRequestType[];
}

export interface IUpdateEmployeeRequest {
  id: string;
  businessId: number;
  restaurantId: number;
  employee: EmployeeI;
  userRole: IUserRolesRequestType[];
}

export interface Urls {
  development: string;
  internal: string;
  uatv2: string;
  stagev2: string;
  main: string;
}

export type Environment = 'development' | 'internal' | 'uatv2' | 'stagev2' | 'main';
export interface IEmployeeWithPermission {
  createEmployeeData: {
    employee: {
      firstName: string;
      lastName: string;
      phoneNumber: string;
      email: string;
    };
    restaurantId: number | undefined;
    businessId: number | undefined;
    id?: string;
    benefits?: BenefitData[];
    userRole: {
      roleId: string;
      salary: number;
      payType: EmployeePayTypeEnum;
    }[];
  };
  userPermissions: IUserPermissionUIPermission[];
}
export interface IEmployeeWithUserBasePermissions {
  email: string;
  firstName: string;
  fullname: string;
  id: string;
  lastName: string;
  phoneNumber: string;
  filterRowsWithRoles: IRolePermissionData[];
  benefits: BenefitData[];
}

export interface IReInvitedData {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  id?: string;
}
